import styled from 'styled-components';

const Container = styled.div`
  margin-top: 20px;
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`;

const Name = styled.div`
  font-size: 22px;
  line-height: 30px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Others = styled.div`
  font-size: 15px;
  line-height: 20px;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const PhoneNumber = styled.div`
  font-size: 13px;
  line-height: 18px;
  font-weight: normal;
`;

export const Styled = {
  Container,
  NameContainer,
  Name,
  Others,
  PhoneNumber,
};
